import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
// PALMATE
import BaseMixer from "@/router/views/BaseMixer";
import Multiselect from "vue-multiselect";
let EcSelect = /** @class */ (() => {
    let EcSelect = class EcSelect extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.controlSelections = [];
        }
        bubbleUpValue(a, b) {
            this.controlSelections = a;
            this.$emit("selection-changed", a);
        }
        removeSelected({ modelIds, id }) {
            const index = this.selectionId.map((x) => x.id).indexOf(id);
            if (index > -1) {
                this.selectionId.splice(index, 1);
            }
        }
        get ddRules() {
            return this.required ? "required|isNot:" + this.emptyGuid.toString() : "";
        }
        get modelIds() {
            return (this.controlSelections = this.models.filter((x) => this.selectionId.map((item) => item.id).includes(x.id)));
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], EcSelect.prototype, "models", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], EcSelect.prototype, "selectionId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EcSelect.prototype, "name", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], EcSelect.prototype, "disabled", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], EcSelect.prototype, "required", void 0);
    EcSelect = __decorate([
        Component({
            name: "EcSelect",
            components: {
                Multiselect,
            },
        })
    ], EcSelect);
    return EcSelect;
})();
export default EcSelect;
